import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.css';
import reportWebVitals from './reportWebVitals';
import VipSale from './pages/vip_sale';
import VipWxPay from './pages/vip_wxpay';
import DefaultPage from './pages/default';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { initRem } from './rem.js';

const router = createBrowserRouter(
  [
    {
      path: '/vip-sale',
      element: <VipSale />,
    },
    {
      path: '/vip-wxpay',
      element: <VipWxPay />,
    },
    {
      path: '/default',
      element: <DefaultPage />,
    },
  ],
  {
    basename: '/single-h5',
  }
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
initRem();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
